<script setup>
/**
 * A thin progress bar for the foot of a stat card. The track is one step off
 * the surface and the fill carries the card's own colour, so it reads as part
 * of the figure above it rather than as decoration.
 */
import { computed } from 'vue'

const props = defineProps({
  value: { type: Number, default: 0 }, // 0…1
  color: { type: String, default: 'var(--c-accent)' },
  label: { type: String, default: '' },
})

const share = computed(() => Math.min(1, Math.max(0, Number(props.value) || 0)))
const percent = computed(() => Math.round(share.value * 100))
</script>

<template>
  <div
    class="mt-2.5 h-1.5 w-full overflow-hidden rounded-full bg-line-soft"
    role="progressbar"
    :aria-label="label"
    :aria-valuenow="percent"
    aria-valuemin="0"
    aria-valuemax="100"
  >
    <!-- A sliver stays visible at zero, so the bar reads as empty rather than absent. -->
    <div
      class="h-full rounded-full transition-[width] duration-300"
      :style="{ width: `${Math.max(share > 0 ? 3 : 0, percent)}%`, background: color }"
    />
  </div>
</template>
